// How a request's payment should read on the trader's cards: one full payment,
// or a deposit plus a balance. Plan item 7ج (2026-09-28): a request paid in
// full (100%) read "deposit paid + remainder due", because every card computed
// `payment_pct > 0 ? payment_pct : 30` and telr-verify never wrote
// requests.payment_pct — it recorded 100 on the PAYMENTS row only. So the
// fallback 30 won, and a fully paid trader was told a balance was owed.
//
// Precedence, strongest evidence first:
//   1. requests.payment_pct — what was actually PAID (telr-verify syncs it
//      after every payment since this change; the M-10096 row is corrected by
//      supabase/migrations/20260929011000_m10096_paid_in_full.sql).
//   2. requests.payment_plan = 100 — the trader chose full payment.
//   3. 30 — the historical default, kept for rows with neither.
//
// Pure: no React, no Supabase. Mirrored in maabar-app src/lib/paymentProgress.js.

export const PAID_IN_FULL = { ar: 'مدفوع بالكامل', en: 'Paid in full', zh: '已全额付款' };
export const FULL_PAYMENT = { ar: 'دفعة كاملة', en: 'Full payment', zh: '全额付款' };

export function paymentSplit(request) {
  const stored = Number(request?.payment_pct);
  if (Number.isFinite(stored) && stored > 0) {
    const pct = Math.min(Math.round(stored), 100);
    return { pct, full: pct >= 100, source: 'paid' };
  }
  if (Number(request?.payment_plan) === 100) return { pct: 100, full: true, source: 'plan' };
  return { pct: 30, full: false, source: 'default' };
}

// The balance still owed, or 0. A full payment never owes a balance, whatever
// a stale payment_second says.
export function balanceDue(request, total) {
  const { pct, full } = paymentSplit(request);
  if (full) return 0;
  const stored = Number(request?.payment_second);
  if (Number.isFinite(stored) && stored > 0) return stored;
  const t = Number(total);
  return Number.isFinite(t) && t > 0 ? parseFloat((t * (100 - pct) / 100).toFixed(2)) : 0;
}

export const paidInFullLabel = (lang) => PAID_IN_FULL[lang] || PAID_IN_FULL.en;
export const fullPaymentLabel = (lang) => FULL_PAYMENT[lang] || FULL_PAYMENT.en;
